{
  "pageTitle": "Media import center",
  "pageSubtitle": "Bulk import or update media units from an XLSX or CSV file",
  "stepper": {
    "upload": "File",
    "supplierDedup": "Suppliers",
    "mapping": "Mapping",
    "validation": "Validation",
    "progress": "Import",
    "result": "Results"
  },
  "upload": {
    "dropZoneTitle": "Drag a file here or click to select",
    "dropZoneSubtitle": "Supported formats: .xlsx, .xls, .xlsm, .csv, .zip or .jpg/.png photos (max. 10 MB / 500 MB for .zip or photos, max. 500 photos at once)",
    "selectFile": "Select file",
    "filePreviewRows": "{{sizeKb}} KB, approx. {{rows}} data rows",
    "filePreviewSize": "{{sizeKb}} KB",
    "validTemplateStatus": "Valid XLSX template",
    "removeFile": "Remove file",
    "noFile": "Don't have a file?",
    "downloadTemplateOoh": "OOH template",
    "downloadTemplateDooh": "DOOH template",
    "nextButton": "Validation",
    "uploading": "Uploading...",
    "errorSizeExceeded": "The file is too large (max. 10 MB)",
    "errorSizeExceededZip": "The ZIP is too large (max. 500 MB)",
    "errorNonStandard": "The file doesn't match the standard template. Download the template and fill in the data.",
    "errorInvalidFileType": "Unsupported file format. Allowed formats: .xlsx, .xls, .xlsm, .csv, .zip",
    "errorGeneric": "An error occurred while uploading the file",
    "errorTemplateDownload": "Failed to download the XLSX template. Please try again.",
    "errorMixedFileTypes": "Select only JPG/PNG photos or a single ZIP/XLSX file",
    "errorTooManyPhotos": "Too many photos at once (max. {{max}})",
    "photosSelectedLabel": "{{count}} photos selected",
    "uploadPhotosButton": "Upload photos",
    "supplierSelectPlaceholder": "Select supplier",
    "supplierSearchPlaceholder": "Search supplier...",
    "supplierNoResults": "No results",
    "supplierLoadError": "Failed to load the supplier list"
  },
  "jobNotFound": {
    "title": "Import not found",
    "description": "This import does not exist or the page address is invalid. Start the import again from the beginning.",
    "action": "Back to upload"
  },
  "validation": {
    "errorChip": "{{count}} error",
    "errorsChip": "{{count}} errors",
    "warningChip": "{{count}} warning",
    "warningsChip": "{{count}} warnings",
    "autofixBanner": "The system automatically fixed <strong>{{count}} rows</strong> before validation",
    "autofixCount": "{{count}} auto-fixes",
    "autofixExpandAll": "Expand all",
    "autofixCollapseAll": "Collapse all",
    "summaryValid": "Valid",
    "summaryErrors": "Errors",
    "summaryAutofixes": "Auto-fixes",
    "summarySkipped": "To be skipped",
    "tableHeaderRow": "Row",
    "tableHeaderUnit": "Media unit",
    "tableHeaderField": "Field",
    "tableHeaderMessage": "Message",
    "tableHeaderType": "Type",
    "tableHeaderOriginal": "Original value",
    "tableHeaderFixed": "Fixed value",
    "tableHeaderFixType": "Fix type",
    "severityError": "Error",
    "severityWarning": "Warning",
    "warningText": "Rows with errors will not be imported. Fix the XLSX file and import again, or choose to import while skipping errors.",
    "allRowsHaveErrors": "All rows contain errors",
    "downloadErrorReport": "Download error report",
    "backToUpload": "Back to upload",
    "importButton": "Import",
    "loading": "Validating...",
    "fetchError": "Failed to validate the file. Please try again.",
    "retryButton": "Try again",
    "expandRow": "Preview",
    "collapseRow": "Hide preview",
    "empty": "empty",
    "autofixHeading": "The system automatically fixed {{count}} rows before validation",
    "autofixEmpty": "No automatic fixes",
    "issuesExpandAll": "Expand all",
    "issuesCollapseAll": "Collapse all",
    "tableHeaderNosnik": "Media unit",
    "tableHeaderKind": "Fix type",
    "importButtonSkip": "Import (skipping errors)",
    "rowDetailLabel": "Data preview — row {{row}}",
    "hideEmptyColumns": "Hide empty columns",
    "errors": {
      "unknown_tag_code": "Unknown tag: \"{{value}}\"",
      "field_required": "Field {{field}} is required",
      "grw_id_or_supplier_number_required": "Internal number or supplier number is required",
      "field_too_long": "Field {{field}} cannot exceed {{max}} characters",
      "unknown_field_value": "Unknown value for field {{field}}: \"{{value}}\"",
      "field_out_of_range": "Field {{field}} must be in the range {{min}}–{{max}}",
      "decimal_comma_autofix": "Decimal comma replaced with a period",
      "multiformat_too_long": "Multiformat cannot exceed {{max}} characters",
      "unknown_media_type": "Unknown or missing media type: \"{{value}}\"",
      "legacy_column_ignored": "Column \"{{column}}\" was removed from the template and will be ignored",
      "row_internal_error": "Failed to process the row due to an internal error",
      "multiformat_sync_failed": "Failed to sync large-format group \"{{code}}\"",
      "pattern_no_match": "Value \"{{value}}\" in column \"{{field}}\" does not match pattern \"{{pattern}}\"",
      "photo_renditions_failed": "Photo saved, but thumbnails could not be prepared"
    }
  },
  "progress": {
    "heading": "Import in progress...",
    "photoBundleProgress": "Processing photos…",
    "processed": "Processed",
    "photoBundleProcessed": "Uploaded",
    "of": "of",
    "rows": "rows",
    "photos": "photos",
    "progressLabel": "Progress",
    "imported": "Imported",
    "updated": "Updated",
    "errors": "Errors (so far)",
    "photoUploaded": "Uploaded",
    "photoNotMatchedOrErrors": "Unmatched / errors"
  },
  "mapping": {
    "stepperLabel": "Mapping",
    "loading": "Loading columns...",
    "errorMissingRequired": "A required field is missing from the mapping. Fill in the missing fields.",
    "nonStandardBanner": "The standard file format was not recognized. Assign columns manually.",
    "columnHeaderSource": "Column in file",
    "columnHeaderTarget": "Field in system",
    "skipColumnOption": "Skip this column",
    "fieldSearchPlaceholder": "Search field...",
    "fieldNoResults": "No results",
    "groupGeneral": "General fields",
    "groupPhysical": "Physical dimensions",
    "groupMuralFlags": "Mural - variants",
    "groupDigital": "Digital",
    "groupInternalCost": "Internal costs",
    "groupClientPrice": "Client prices",
    "supplierLabel": "Supplier",
    "supplierSelectPlaceholder": "Select supplier",
    "supplierSearchPlaceholder": "Search supplier...",
    "supplierNoResults": "No results",
    "nextButton": "Next",
    "unmappedRequiredHeading": "Required fields without assignment",
    "unmappedRequiredHint": "The required fields below have not been assigned to any column. Complete the mapping.",
    "missingRequiredHeading": "Missing fields in the supplier file",
    "missingRequiredHint": "The supplier file does not contain columns for the following required fields. Contact the supplier.",
    "fetchError": "Failed to load the column mapping.",
    "retryButton": "Try again",
    "unknownColumn": "(unknown column)",
    "typeOverrideLabel": "Media type for the whole file",
    "typeOverridePlaceholder": "(varies / per row)",
    "typeOverrideAutoNote": "auto: file-level override",
    "typeOverrideFilteredHint": "Showing columns for type: {{type}}",
    "editPatternAriaLabel": "Edit match pattern",
    "fanOutNoteLabel": "see below",
    "unmatchedSampleWarningLabel": "The pattern doesn't match one of the sample values",
    "fieldInfoAriaLabel": "Field information",
    "patternDialogTitle": "Edit match pattern",
    "patternColumnLabelPrefix": "Column:",
    "patternSampleValueTemplate": "Example: {value}",
    "patternFieldLabel": "Pattern",
    "patternAutoDetectedNote": "(auto-detected)",
    "patternPlaceholder": "e.g. {1}, {2} / {3}",
    "patternUnderstandingLabel": "How does this work?",
    "patternUnderstandingInfoLabel": "How does this work?",
    "patternUnderstandingInfoText": "Enter {1}, {2}, etc. where values that should go into separate fields appear. The remaining text must exactly match the sample value.",
    "patternNoBlanksHint": "This pattern contains no placeholders — the column will be mapped directly.",
    "patternMatchedTemplate": "Matches {matched} of {total} sample values",
    "patternNoMatchText": "The pattern doesn't match the sample value",
    "patternShowMismatchesLabel": "Show mismatches",
    "patternHideMismatchesLabel": "Hide mismatches",
    "patternDoneButtonLabel": "Done",
    "recognizedLayoutText": "Column layout recognized from a previous import",
    "recognizedLayoutInfoLabel": "How does layout recognition work?",
    "recognizedLayoutInfoText": "The file's columns are compared against a signature (the number and names of headers) saved from a previous import. On a match, the remembered mapping and transformation configuration is applied automatically.",
    "recognizedLayoutClearLabel": "Clear configuration",
    "valueMapDialogTitle": "Edit value map",
    "valueMapFromColumnLabel": "Value from file",
    "valueMapToColumnLabel": "Value in system",
    "valueMapUnmappedPlaceholder": "[select…]",
    "valueMapBlockedWarningTemplate": "The import is blocked until the value \"{value}\" is mapped.",
    "constantDialogTitle": "Edit constant value",
    "constantValueFieldLabel": "Constant value for all rows",
    "constantEditAriaLabel": "Set constant value",
    "constantAssignedTemplate": "→ constant: {value}",
    "sheetPickerLabel": "Sheet",
    "headerAutoNoteTemplate": "Header: row {row} · empty columns skipped",
    "headerAutoInfoLabel": "How is the header detected?",
    "headerAutoInfoText": "The system automatically detects the header row (first non-empty row) and skips fully empty columns, including empty columns at the start of the file. You don't need to indicate this manually.",
    "fileSummaryTemplate": "{sizeKb} KB · ~{rows} rows",
    "fileSummaryTemplateRowsOnly": "~{rows} rows",
    "previewHeading": "Preview of imported data ({count})",
    "previewRegionDerivedWarning": "Region derived from coordinates",
    "transformModePatternLabel": "Pattern",
    "transformModeValueMapLabel": "Value dictionary",
    "modeToggleInfoLabel": "How do the modes differ?",
    "modeToggleInfoText": "Pattern — extracts a value from the cell according to a template with {1}, {2} placeholders. Value dictionary — maps specific values from the file to specific values in the system (e.g. \"B360\" → \"billboard\").",
    "constantTypeOptions": {
      "billboard": "Billboard",
      "backlight": "Backlight",
      "citylight": "Citylight",
      "słup": "Pillar",
      "cityscroll": "Cityscroll",
      "konstrukcja": "Structure",
      "wielki format": "Large format",
      "mural": "Mural",
      "dooh": "DOOH",
      "inne": "Other"
    },
    "transformDialogInfoLabel": "How does this transform mapping work?",
    "transformDialogInfoText": "This dialog lets you convert the column's raw values into what the system expects. Use \"Pattern\" to extract one or more values from the raw text using {1}, {2} placeholders. Use \"Value map\" to map each value found in the file directly to its system equivalent.",
    "constantValueSearchPlaceholder": "Search values...",
    "enumOptionsLoadingLabel": "Loading values...",
    "enumOptionsErrorLabel": "Failed to load the format list"
  },
  "result": {
    "headingSuccess": "Import complete",
    "headingWithErrors": "Import completed with errors",
    "processed": "Processed {{totalRows}} rows",
    "statImported": "Imported",
    "statUpdated": "Updated",
    "statSkipped": "Skipped",
    "statErrors": "Errors",
    "statUploaded": "Uploaded",
    "statWarnings": "Warnings",
    "viewImportedButton": "View imported media units",
    "downloadErrorReport": "Download error report ({{count}} rows)",
    "downloadErrorReportFailed": "Failed to download the error report",
    "errorReportColumnRow": "Row",
    "errorReportColumnGrwId": "GRW number",
    "errorReportColumnField": "Field",
    "errorReportColumnMessage": "Message",
    "errorReportColumnSeverity": "Severity",
    "goToInventory": "Go to media catalog",
    "messages": {
      "uploadedSuccessfully": "Imported successfully",
      "noMediaUnitFound": "Skipped: no media unit found for supplier number '{{supplierNumber}}'",
      "nestedZipDirectoryNotSupported": "Skipped: nested ZIP directories are not supported",
      "unrecognizedImageFile": "Skipped: unrecognized image file ({{extension}})",
      "couldNotParseSupplierNumber": "Skipped: could not read the supplier number from the file name",
      "photoLimitReached": "Skipped: photo limit reached (max. {{limit}} per media unit)",
      "photoAlreadyPresent": "Photo already exists, kept",
      "uploadFailed": "Upload failed, contact support if the problem persists",
      "associationFailed": "Photo uploaded, but the unit may be missing from the imported-units list (association write failed)",
      "uploadedRenditionsFailed": "Photo saved, but thumbnails could not be prepared",
      "photoRenditionsFailed": "Photo saved, but thumbnails could not be prepared"
    },
    "unmatchedCallout": "{{count}} photos were not matched to any media unit",
    "photosBundleSuccess": "Photos imported",
    "photoBundleTableHeaderFile": "File",
    "photoBundleTableHeaderStatus": "Status",
    "photoBundleTableHeaderMessage": "Message",
    "backToImport": "Back to import"
  },
  "supplierDedup": {
    "heading": "Supplier verification",
    "subheading": "Supplier names similar to existing ones were found. Choose an action for each of them.",
    "useExistingLabel": "Use existing",
    "similaritySuffix": "match",
    "createNewLabel": "Create new supplier",
    "nextButton": "Next",
    "submitting": "Saving...",
    "errorGeneric": "Failed to save the decision. Try again.",
    "columnFileName": "Name in file",
    "columnAction": "Action",
    "columnSuggestions": "Similar suppliers in the system",
    "allDecidedHint": "Choose an action for each supplier in the list above."
  }
}
